import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIconButton from 'Src/components/buttons/CloseIconButton';
import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { useDataTable } from 'Src/feature/data-table/useDataTable';
import { useEmployee } from 'Src/feature/employee/useEmployee';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

import { useCashBank } from './useCashBank';

const CashBankLog: FC = () => {
  const { t } = useTranslation();
  const { data: currentCashBank } = useCashBank.query.current();
  const employeeGetAllMap = useEmployee.query.map();
  const [modalOpen, setModalOpen] = useState(false);

  const { Table, Column, store: tableStore } = useDataTable({ data: currentCashBank?.bankLog || [] });
  const showPagination = tableStore.data.all.length > 15;

  return (
    <>
      <CTA onClick={() => setModalOpen(true)} label={t('cashBank.labels.viewBankLog')} />
      <Modal
        data-testid="cash-bank-log-modal"
        open={modalOpen}
        onBackDropClick={() => setModalOpen(false)}
      >
        <ModalHeader closeButton={<CloseIconButton onClick={() => setModalOpen(false)} />}>
          <ModalTitle copy={t('cashBank.labels.bankLog')} />
        </ModalHeader>

        <ModalContent>
          <Table
            pagination={showPagination ? undefined : <></>}
            noDataMessage={t('cashBank.errors.bankLog_noData')}
            orderBy="createdAt"
          >
            <Column label={t('labels.activityType')} field="eventType" width={250} />
            <Column
              label={t('labels.amount')}
              width={100}
              cellContentRenderer={({ dataItem: { value } }) => (
                <Copy
                  type="currency"
                  value={value}
                  color={typeof value === 'number' && value < 0 ? 'error' : undefined}
                />
              )}
            />
            <Column
              label={t('labels.notes')}
              width={300}
              cellContentRenderer={({ dataItem: { notes } }) => (
                <Copy optional disabled value={notes}/>
              )}
            />
            <Column
              label={t('employee.label')}
              width={200}
              align="right"
              cellContentRenderer={({ dataItem: { employeeId } }) => {
                const employee = employeeGetAllMap.data?.get(employeeId);
                return (
                  <Copy optional value={employee ? t('labels.util.employeeFullName', employee) : undefined} />
                );
              }}
            />
          </Table>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CashBankLog;
